import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcRestaurant(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.538 18.794c0-.57.322-1.09.833-1.344a7.61 7.61 0 0 0 4.078-5.31H4.552a7.61 7.61 0 0 0 4.078 5.31 1.5 1.5 0 0 1 .833 1.344V19a.5.5 0 0 0 .5.5h4.075a.5.5 0 0 0 .5-.5zm1.5 0a9.1 9.1 0 0 0 5.004-7.155c.06-.55-.393-.998-.946-.998H3.904c-.552 0-1.005.449-.946.998a9.1 9.1 0 0 0 5.005 7.155v.706a1.5 1.5 0 0 0 1.5 1.5h5.074a1.5 1.5 0 0 0 1.5-1.5v-.706",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 4.25c-3.387 0-6.281 3.124-6.281 7.172h-1.5C4.219 6.719 7.62 2.75 12 2.75c4.38 0 7.781 3.97 7.781 8.672h-1.5c0-4.048-2.893-7.172-6.281-7.172",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M18.352 2.812a.75.75 0 0 1 .21 1.04l-3 4.53a.75.75 0 1 1-1.25-.827l3-4.531a.75.75 0 0 1 1.04-.212M20.865 5.118a.75.75 0 0 1-.045 1.06l-1.907 1.75A.75.75 0 1 1 17.9 6.823l1.906-1.75a.75.75 0 0 1 1.06.045",
    clipRule: "evenodd"
  }));
}
var IcRestaurant = createNolIcon(/*#__PURE__*/forwardRef(SvgIcRestaurant));

export { IcRestaurant as I };
